export default {
  title: 'Login',
  welcomeBack: 'Welcome Back!',
  email: 'Email',
  password: 'Password',
  login: 'Login',
  forgotYourPassword: 'Forgot your password?',
  getStarted: "Don't have an account? Get Started",
}